export enum QuestionnaireAnswers {
  Yes = 'Yes',
  No = 'No',
  Unsure = 'Unsure',
}
